module.exports = __webpack_public_path__ + "img/West-Mermis-Case-Study-150px.2ca48ad8.png";